import React from 'react';
import { isEmpty } from 'lodash';

import { styled } from '@this/constants/themes';
import { media } from '@this/src/components/shared/atoms/media';
import { HOTEL_PLAN_POINT_NOTICE } from '@this/domain/hotel_element2';

import StayPlanWarning from '../../reserve_trip/select/shared/stay_plan_warning';

interface Props {
  line: string;
  prevLine: string | undefined;
  kind?: string;
}

const InAdvanceApplicationOrderItemDetailLine: React.FC<Props> = ({
  line: tempLine,
  prevLine: tempPrevLine,
  kind
}) => {
  // ホテルのユーザー属性による除外ワードが含まれるプランは、RESTRICTED!を付与している
  const restricted = tempLine.startsWith('RESTRICTED!');
  const prevRestricted = tempPrevLine ? tempPrevLine.startsWith('RESTRICTED!') : false;

  const line = restricted ? tempLine.replace('RESTRICTED!', '') : tempLine;
  const prevLine = prevRestricted && tempPrevLine ? tempPrevLine.replace('RESTRICTED!', '') : tempPrevLine || '';
  const changed = line !== prevLine && !isEmpty(prevLine);

  return (
    <>
      {changed && (
        <p style={{ textDecoration: 'line-through', textDecorationColor: '#a72c09' }}>
          {isEmpty(prevLine) ? <br /> : prevLine}
        </p>
      )}
      {restricted ? (
        <RestrictedWrapper>
          <p style={changed ? { color: '#a72c09' } : {}}>{line}</p>
          <StayPlanWrapper>
            <StayPlanWarning variant="text" restricted />
          </StayPlanWrapper>
        </RestrictedWrapper>
      ) : (
        <p style={changed ? { color: '#a72c09' } : {}}>{isEmpty(line) ? <br /> : line}</p>
      )}
      {kind === 'plan_name' && <p style={{ fontSize: '10px', color: '#7d7d7d' }}>{HOTEL_PLAN_POINT_NOTICE}</p>}
    </>
  );
};

const RestrictedWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 4px 0;

  ${media.sp`
    flex-direction: column;
    gap: 2px;
  `}
`;

const StayPlanWrapper = styled.span`
  line-height: 1.876; // 1行分の高さに合わせる
`;

export default InAdvanceApplicationOrderItemDetailLine;
